<template>
  <div class="row">
    <div class="col">
      <div class="card card-modern">
        <div>
          <div class="datatables-header-footer-wrapper">
            <div class="datatable-header mb-3 mx-2">
              <div class="row align-items-center mb-3">
                <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                  <button
                    data-bs-toggle="modal"
                    type="button"
                    :data-bs-target="`#${modalId}`"
                    class="
                      btn btn-primary btn-md
                      font-weight-semibold
                      btn-py-2
                      px-4
                    "
                  >
                    <i class="bx bx-upload text-lg-4 py-1" /> Upload
                  </button>
                </div>
                <div class="col-8 col-lg-auto ms-auto ml-auto mb-3 mb-lg-0">
                </div>
                <div class="col-4 col-lg-auto ps-lg-1 mb-3 mb-lg-0">
                  <div
                    class="d-flex align-items-lg-center flex-column flex-lg-row"
                  >
                    <label class="ws-nowrap me-3 mb-0">Show:</label>
                    <select
                      class="form-control select-style-1 results-per-page"
                      name="results-per-page"
                      v-model="searchConfig.pageSize"
                      @change="changePageSize(searchConfig.pageSize)"
                    >
                      <option
                        :value="page"
                        v-for="page in pageSizeList"
                        :key="page"
                      >
                        {{ page }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-lg-auto ps-lg-1">
                  <div
                    class="search search-style-1 search-style-1-lg mx-lg-auto"
                  >
                    <div class="input-group">
                      <input
                        type="text"
                        class="search-term form-control"
                        style="border"
                        placeholder="Search"
                        v-model="searchField"
                        @input="debounceInput"
                      />
                      <button class="btn btn-default" type="submit">
                        <i class="bx bx-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="dataTables_wrapper dt-bootstrap5 no-footer">
              <div class="row justify-content-between">
                <div class="col-auto"></div>
                <div class="col-auto"></div>
              </div>
            </div>
            <div>
              <div class="row row-gutter-sm">
                <div
                  class="col-sm-6 col-md-4 col-xl-2 mb-3"
                  v-for="item in library"
                  :key="item.id"
                >
                  <div class="card card-modern card-modern-alt-padding">
                    <div class="card-body p-2 bg-light">
                      <div class="image-frame mb-2">
                        <div class="image-frame-wrapper">
                          <photo :src="`'${baseUrl}${item.url}'`" />
                        </div>
                      </div>
                      <div class="d-flex justify-content-between image-action">
                        <div class="checkbox-custom checkbox-default">
                          <input
                            type="checkbox"
                            :value="item"
                            :id="item.id"
                            :checked="isChecked(item)"
                            @change="toggleCheckbox(item)"
                          />
                          <label></label>
                        </div>
                        <label :for="item.id" class="file-name">
                          {{ item.fileName }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr class="solid mt-5 opacity-4" />
          </div>
        </div>
      </div>
    </div>

    <div class="row px-3">
      <pagination class="col-12" :action="actionName" :pagination-props="paginationProps" />
    </div>
    <!-- end: page -->
  </div>
</template>

<script>
import { translations, pager } from '@/mixins';
import Photo from '@/components/shared/Photo.vue';
import Pagination from '../shared/Pagination.vue';

import config from '@/config';

export default {
  name: 'MediaLibrary',
  props: {
    value: Array,
    modalId: {
      type: String,
      default: 'upload-modal',
    },
  },
  model: {
    get() {
      this.selected = this.value;
      return this.value;
    },
    set(value) {
      this.value = value;
      this.$emit('input', value);
    },
  },
  mixins: [translations, pager],
  components: {
    Photo,
    Pagination
  },
  data() {
    return {
      selected: this.value || [],
      actionName: 'getMediaLibrary',
    };
  },
  computed: {
    articleModalText() {
      return this.translations.areYouSureSelected;
    },
    library() {
      return this.$store.getters.getMediaLibrary;
    },
    baseUrl() {
      return config.baseUrl;
    },
    paginationProps() {
      return {
        quickSearch: this.searchField.trim(),
        fileType: 1,
      };
    },
  },
  methods: {
    isChecked(item) {
      return !!this.value.find((i) => i.mediaLibraryFileId === item.id || i.id === item.id);
    },
    toggleCheckbox(item) {
      const index = this.selected.findIndex((i) => item.id === i.id);

      if (index === -1) {
        this.selected.push(item);
      } else {
        this.selected.splice(index, 1);
      }
    },
  },
  mounted() {
    this.$store.dispatch(this.actionName, {...this.searchConfig, fileType: 1 });
  },
  watch: {
    selected(newVal) {
      this.$emit('input', newVal);
    },
    value(newVal) {
      this.selected = newVal;
    },
  },
};
</script>
<style lang="scss" scoped>
.image-action div {
  > .bx {
    color: #000;
  }
}

.file-name {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
</style>
